/**
 * Helps to know when we do something in the Form
 */
export enum FORM_EVENT {
	UPDATE = 'FORM_UPDATE',
	PHOTO_SELECT = 'PHOTO_SELECT',
	PHOTO_PRIMARY = 'PHOTO_PRIMARY',
	DYNAMIC_FORM_EDITABLE = 'DYNAMIC_FORM_EDITABLE',
	PHOTO_SELECT_ALL_NONE = 'PHOTO_SELECT_ALL_NONE',
	TELEMETRY = 'FORM_TELEMETRY'
}

export enum PHOTO_SELECT_STATUS {
	SELECTED = 'photo_selected',
	UNSELECTED = 'photo_unselected'
}

export enum SCHEMA_TYPE_CONST {
	'CVReview:1' = 'CV_REVIEW',
	'CVReview1073:1' = 'CV_REVIEW_1073',
	'CVReview1075:1' = 'CV_REVIEW_1075',
	'CVReview2055:1' = 'CV_REVIEW_2055',
	'InspectionReport:3' = 'CVDS_3',
	'InspectionReport:3.1' = 'CVDS_31',
	'InspectionReport:3.2' = 'CVDS_32',
	'InspectionReport:3.3' = 'CVDS_33',
	'InspectionReport:3.4' = 'CVDS_34',
	'InspectionReport:4' = 'CVDS_40',
	'Inspectionless:1' = 'INSPECTIONLESS_1',
	'Inspectionless:1.1' = 'INSPECTIONLESS_11'
}

// Duplicated from Quality module
export enum SCHEMA_TYPE {
	CV_REVIEW = 'CVReview:1',
	CV_REVIEW_1073 = 'CVReview1073:1',
	CV_REVIEW_1075 = 'CVReview1075:1',
	CV_REVIEW_2055 = 'CVReview2055:1',
	CVDS_3 = 'InspectionReport:3',
	CVDS_31 = 'InspectionReport:3.1',
	CVDS_32 = 'InspectionReport:3.2',
	CVDS_33 = 'InspectionReport:3.3',
	CVDS_34 = 'InspectionReport:3.4',
	CVDS_40 = 'InspectionReport:4',
	INSPECTIONLESS_1 = 'Inspectionless:1',
	INSPECTIONLESS_11 = 'Inspectionless:1.1',
}

export enum SCHEMA_PHOTO_PATH {
	'InspectionReport:3.2' = 'InspectionReport.property.{index}[{index}]',
	'InspectionReport:3.3' = 'InspectionReport.property.structures[0].units[0].levels[{index}].rooms[{index}]',
}

export enum DOCUMENT_RULES_UI_SECTIONS {
	PDFREVIEW = 'PDFREVIEW',
	PHOTOREVIEW = 'PHOTOREVIEW',
	SUBJECT = 'SUBJECT',
	NEIGHBORHOOD = 'NEIGHBORHOOD',
	IMPROVEMENTS = 'IMPROVEMENTS',
	PROJECTANALYSIS = 'PROJECTANALYSIS',
	PROJECTINFORMATION = 'PROJECTINFORMATION',
	UNITDESCRIPTION = 'UNITDESCRIPTION',
	OVERVIEW = 'OVERVIEW',
	COMPS = 'COMPS',
	REVISIONS = 'REVISIONS',
	SALESAPPROACH = 'SALESAPPROACH',
	COSTAPPROACH = 'COSTAPPROACH',
	INCOMEAPPROACH = 'INCOMEAPPROACH',
	RECONCILIATION = 'RECONCILIATION',
	VIRTUALTOUR = 'VIRTUALTOUR',
	ARRIVAL = 'ARRIVAL',
	SITE = 'SITE',
	STRUCTURES = 'STRUCTURES'
}

export const PUBLIC_RECORD_SELECTED = 'PUBLIC_RECORD_SELECTED'
